module.exports = __webpack_public_path__ + "img/co1.4b12bf1f.png";